import { render, staticRenderFns } from "./AppMenuItem.vue?vue&type=template&id=6f8600fd&scoped=true"
import script from "./AppMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuItem.vue?vue&type=style&index=0&id=6f8600fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8600fd",
  null
  
)

export default component.exports